module.exports = __webpack_public_path__ + "img/logo.8d384c65.png";